import { render, staticRenderFns } from "./ProductList1.vue?vue&type=template&id=0e10c9c5&scoped=true&"
import script from "./productlist1.js?vue&type=script&lang=js&"
export * from "./productlist1.js?vue&type=script&lang=js&"
import style0 from "./ProductList1.vue?vue&type=style&index=0&id=0e10c9c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10c9c5",
  null
  
)

export default component.exports